// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__DMmf-","content":"styles_content__y23Z9","tableWrap":"styles_tableWrap__ZFNcA"};